module.exports = __webpack_public_path__ + "img/lun2.9bce2845.webp";